export default __webpack_public_path__ + "static/hero-144a-2c5b5c5af1cbddcfce85b4b189c84af1.jpg";